import hasOwnProperty from '.Object.prototype.hasOwnProperty';

import { PropertyName } from './Name';
import Primitive from './Primitive';

export function ObjectLiteral (object                        , options   
	            
	                                          
	                                           
	                  
	                                            
	                     
	                                           
	                                           
	                   
 )         {
	var pairs           = [];
	var pairs_length         = 0;
	var open         = '{';
	var close         = '}';
	var _colon_         = ( options.key_colon || '' )+':'+( options.colon_value || '' );
	var ES         = options.ES || 0;
	for ( var key in object ) {
		if ( hasOwnProperty.call(object, key) ) {
			var value = Primitive(object[key                ], key, object, options      );
			if ( value ) {
				if ( key==='__proto__' && !options.__safe__ ) {
					if ( ES>=6 ) { key = '[\'__proto__\']'       ; }
					else {
						open = '/*#__PURE__*/function(p,o){o.__proto__=_.p;return o}({'+( options.open_first || '' )+'p'+_colon_+value+( options.last_close || '' )+'},{';
						close = '})';
						value = 'null';
					}
				}
				else { key = PropertyName(key, ES)       ; }
				pairs[pairs_length++] = key+_colon_+value;
			}
		}
	}
	return open+(
		pairs_length
			? ( options.open_first || '' )+pairs.join(( options.value_comma || '' )+','+( options.comma_next || '' ))+( options.last_close || '' )
			: ( options.open_close || '' )
	)+close;
}
